import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQuery } from "@/shared/utils/baseQuery";

type RegisterRequest = {
  email: string;
  password: string;
  fullname: string;
};

type LoginRequest = {
  email: string;
  password: string;
};

type RefreshTokenRequest = {
  refresh_token: string;
};

type AuthResponse = {
  access_token: string;
  refresh_token: string;
  token_type: string;
  user_id: number;
};

type RefreshResponse = {
  access_token: string;
  token_type: string;
};

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: createBaseQuery("https://api.fitkeep.ru/"),
  endpoints: (builder) => ({
    register: builder.mutation<AuthResponse, RegisterRequest>({
      query: (body) => ({
        url: "/auth/register",
        method: "POST",
        body,
      }),
    }),
    login: builder.mutation<AuthResponse, LoginRequest>({
      query: (body) => ({
        url: "/auth/login",
        method: "POST",
        body,
      }),
    }),
    refresh: builder.mutation<RefreshResponse, RefreshTokenRequest>({
      query: (body) => ({
        url: "/auth/refresh",
        method: "POST",
        body,
      }),
    }),
    logout: builder.mutation<{ status: string }, RefreshTokenRequest>({
      query: (body) => ({
        url: "/auth/logout",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useRegisterMutation,
  useLoginMutation,
  useRefreshMutation,
  useLogoutMutation,
} = authApi;
